import React from "react";
import top from "../imgs/top-companies.png";

const Top = () => {
  return (
    <div className="topcom">
      <img src={top} alt="" />
    </div>
  );
};

export default Top;
